import axios from "axios";
import { isString, isArray, each } from "lodash";
import { apiHost } from "../../config";
import { store } from "../store";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions";
// import * as API from "../api";

import { env } from "../../config";

// const uuidv4 = require("uuid/v4");

export const APIHost = () => {
  let host = apiHost[env];
  return host;
};

export const SetAxiosAuthBearer = (jwt_bearer) => {
  axios.defaults.headers.common["Authorization"] = jwt_bearer;
};

export const SetAxiosDefaultConfig = () => {
  if (store.getState().Auth.jwt_token !== null) {
    SetAxiosAuthBearer(store.getState().Auth.jwt_token);
  } else {
    SetAxiosAuthBearer(store.getState().Auth.device_token);
  }
  axios.defaults.timeout = 25000;
  axios.interceptors.response.use(
    (response) => {
      if (store.getState().App.app_connection === false) {
        store.dispatch({
          type: actionTypes.RESET_APP_STATE,
        });
      }

      return response;
    },
    (error) => {
      // Capture network error (no internet connection and etc)
      if (error.request && error.request._hasError) {
        if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
          //   console.log("request error");
          //   console.log(error.request);
        }

        if (
          error.request._response &&
          error.request._response ===
            "The Internet connection appears to be offline."
        ) {
          store.dispatch({
            type: actionTypes.NO_INTERNET,
          });
        }

        return Promise.reject({
          response: { data: { message: "Network Problem. Please Retry" } },
        });
      }

      if (error.response && error.response.config) {
        const ori_request = error.response.config;

        // Timeout & retry
        if (
          (error.code && error.code === "ECONNABORTED") ||
          (error.response && error.response.status === 408)
        ) {
          if (typeof ori_request._retry_timeout === "undefined") {
            ori_request._retry_timeout = true;
            return axios(ori_request);
          }
        }
        // Auth Token Invalid (re-auth & retry)
        else if (error.response.status === 401) {
          if (
            error.response.data &&
            error.response.data.message &&
            (error.response.data.message
              .toLowerCase()
              .includes("invaild signature") ||
              error.response.data.message.toLowerCase().includes("jwt expired"))
          ) {
            // dont show error
            store.dispatch(actions.consumerForceLogout());
          } else {
            store.dispatch(
              actions.consumerForceLogout(
                error.response.data && error.response.data.message
                  ? error.response.data.message
                  : ""
              )
            );
          }
          store.dispatch(actions.disableLoading());
          // const loginParams = store.getState().Auth.loginData;
          // const registerDeviceParams = {
          //   uuid: uuidv4(),
          //   app_token: "LOLOL-CONSUMER-WEB"
          // };

          // store.dispatch(actions.enableLoading);
          // // Register Device
          // return API.registerDevice(registerDeviceParams)
          //   .then(res => {
          //     if (res.data.success && res.data.token) {
          //       SetAxiosAuthBearer(res.data.token);

          //       store.dispatch(actions.registerDeviceSuccess(res.data.token));
          //       ori_request.headers["Authorization"] = res.data.token;

          //       if (JSON.stringify(loginParams) !== JSON.stringify({})) {
          //         // Login
          //         return API.login(loginParams)
          //           .then(res => {
          //             if (res.data.success && res.data.token) {
          //               SetAxiosAuthBearer(res.data.token);

          //               store.dispatch(
          //                 actions.consumerLoginSuccess(
          //                   res.data.token,
          //                   res.data.data,
          //                   loginParams
          //                 )
          //               );
          //               ori_request.headers["Authorization"] = res.data.token;

          //               return axios(ori_request);
          //             }
          //           })
          //           .catch(error => {
          //             store.dispatch(actions.consumerLoginFail());
          //             store.dispatch(actions.disableLoading());
          //             window.location("/");
          //             return Promise.reject(error);
          //           });
          //       } else {
          //         return axios(ori_request);
          //       }
          //     }
          //   })
          //   .catch(error => {
          //     store.dispatch(actions.registerDeviceFail());
          //     store.dispatch(actions.disableLoading());
          //     window.location("/");
          //     return Promise.reject(error);
          //   });
        }
      }

      return Promise.reject(error);
    }
  );
};

export const constructErrMsg = (error) => {
  let err_msg = "Error";

  if (error.response && error.response.data && error.response.data.message) {
    if (isString(error.response.data.message))
      err_msg = error.response.data.message;
    else if (isArray(error.response.data.message)) {
      err_msg += ":";

      each(error.response.data.message, (val) => {
        err_msg += "\n[" + val.msg + "]";
      });
    }
  }

  return err_msg;
};
